import { Pause } from '../icons/Pause.icon';
import { StatusCancelled } from '../icons/StatusCancelled.icon';
import { StatusDeleted } from '../icons/StatusDeleted.icon';
import { Unknown } from '../icons/Unknown.icon';
import { Yes } from '../icons/Yes.icon';
import { SVGIconComponent } from '../icons/types';
import { BadgeUserStatus } from './badge-user-status';

export const userStatusToIcon: Record<BadgeUserStatus, SVGIconComponent> = {
  incomplete: Pause,
  pending: Unknown,
  active: Yes,
  inactive: Pause,
  deleted: StatusDeleted,
  // Not the pause a suspension gets: a rejection is a refusal, not a wait.
  rejected: StatusCancelled
};
